const MUTATION_TYPE = {
  setNewConnection: 'setNewConnection',
  removeConnection: 'removeConnection',
  setOnMessage: 'setOnMessage'
}

const ACTION_TYPE = {
  sendMessage: 'sendMessage'
}

const GETTER_TYPE = {
  getSocket: 'getSocket',
  isSocketReady: 'isSocketReady'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
